// extracted by mini-css-extract-plugin
export default {"centeredColumn":"RegistrationTable_centeredColumn__wEF4J"};